'use client'

import { SETTINGS_PANEL_CLASS } from '@/components/dialog/settings/settings-card-styles'
import { NotificationPreferencesCard } from '@/features/settings/notifications/notification-preferences-card'
import { TelegramLinkingCard } from '@/features/settings/notifications/telegram-linking-card'
import { useListSessions } from '@/service/session.hook'

export default function NotificationsPanel() {
  const { data, isLoading, isError } = useListSessions()

  return (
    <div className={SETTINGS_PANEL_CLASS}>
      <NotificationPreferencesCard />
      <TelegramLinkingCard
        sessions={data?.sessions ?? []}
        isLoading={isLoading}
        isError={isError}
      />
    </div>
  )
}
